exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlight-yellow[data-v-064fcce3]:hover {\n  --bg-opacity: 1;\n  background-color: #ffc749;\n  background-color: rgba(255, 199, 73, var(--bg-opacity));\n}\n.active.highlight-yellow[data-v-064fcce3] {\n  --bg-opacity: 1;\n  background-color: #ffc749;\n  background-color: rgba(255, 199, 73, var(--bg-opacity));\n  --text-opacity: 1;\n  color: #004876;\n  color: rgba(0, 72, 118, var(--text-opacity));\n}\n", ""]);

// exports
